<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <div id="myTabContent" class="tab-content">
            <data-table :badges="badges" :items="items" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
 import BadgeStudentsDataTableVue from "./components/BadgeStudentsDataTableVue.vue";

export default {
  name: "BadgeStudents",

  components: {
    "data-table": BadgeStudentsDataTableVue,
  },
  data() {
    return {
      items: {},
      badges: {},
    };
  },
};
</script>
<style>
</style>
